module.exports = __webpack_public_path__ + "img/CRT_Weapon-Wand-03.a7a6c041.png";